"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var ramlFragment = [{
  label: 'Upload a RAML Fragment',
  fields: [{
    name: 'mainFile',
    inputType: 'file',
    classifier: 'raml-fragment',
    extensions: ['.raml'],
    required: true,
    hasMainFile: true,
    mainFileProperty: 'mainFile'
  }]
}];
var oasComponents = [{
  label: 'Upload a JSON Schema',
  fields: [{
    name: 'mainFile',
    inputType: 'file',
    classifier: 'json-schema',
    extensions: ['.json'],
    required: true,
    hasMainFile: true,
    mainFileProperty: 'mainFile'
  }]
}, {
  label: 'Upload an OAS component',
  fields: [{
    name: 'mainFile',
    inputType: 'file',
    classifier: 'oas-components',
    extensions: ['.yaml', '.json'],
    required: true,
    hasMainFile: true,
    mainFileProperty: 'mainFile'
  }]
}];
var avroSchema = [{
  label: 'Upload an AVRO Schema',
  fields: [{
    name: 'mainFile',
    inputType: 'file',
    classifier: 'avro-schema',
    extensions: ['.avsc', '.json'],
    required: true,
    hasMainFile: true,
    mainFileProperty: 'mainFile'
  }]
}];
var setup = function setup(_ref) {
  var config = _ref.config;
  var fragments = ramlFragment;
  if (config.featureFlags['oas-components-enabled']) fragments = fragments.concat(oasComponents);
  if (config.featureFlags['avro-schema-enabled']) fragments = fragments.concat(avroSchema);
  return {
    description: 'Add an API spec fragment that can be composed to create an API spec.',
    flows: fragments
  };
};
var _default = exports.default = setup;
//# sourceMappingURL=form.js.map